import { createAction, props } from '@ngrx/store';
import { VisibleRangeModel, PagedGrid } from '../../models';

export const PagedGridActions = {
  Init: createAction(
    '[Paged grid] init',
    props<{
      instanceId: string;
      pageSize: number;
      chunkSize: number;
      rowChunkSize: number;
      enableChunkCaching?: boolean
    }>(),
  ),
  Dispose: createAction('[Paged grid] dispose', props<{ instanceId: string }>()),
  SetColumnsData: createAction(
    '[Paged grid] set columns data',
    props<{ instanceId: string; columnsData: PagedGrid.ColumnData[] }>(),
  ),
  LoadChunk: createAction(
    '[Paged grid] load chunk',
    props<{
      instanceId: string;
      chunkIndex: number;
      offset: number;
      limit: number;
      sortColumn: string;
      sortDirection: 'asc' | 'desc';
    }>(),
  ),
  ChunkLoaded: createAction(
    '[Paged grid] chunk loaded',
    props<{ instanceId: string; rows: PagedGrid.GridChunkRow[]; chunkIndex: number }>(),
  ),
  SetChunk: createAction(
    '[Paged grid] set chunk',
    props<{ instanceId: string; rows: PagedGrid.GridChunkRow[]; chunkIndex: number }>(),
  ),
  Reload: createAction('[Paged grid] reload table', props<{ instanceId: string; }>()),
  SetDisplayedRange: createAction(
    '[Paged grid] set displayed range',
    props<{ instanceId: string; visibleRange: VisibleRangeModel }>(),
  ),
  SetTotalCount: createAction(
    '[Paged grid] set total count',
    props<{ instanceId: string; totalCount: number }>(),
  ),
  SelectPage: createAction('[Paged grid] select page', props<{ instanceId: string; pageIndex: number }>()),
  CleanNotVisibleChunks: createAction(
    '[Paged grid] clean not visible chunks',
    props<{ instanceId: string; visibleRange: VisibleRangeModel }>(),
  ),
  ShowMoreInRow: createAction(
    '[Paged grid] show more in row',
    props<{ instanceId: string; rowIndex: number; chunkIndex: number }>(),
  ),
  ShowLessInRow: createAction(
    '[Paged grid] show less in row',
    props<{ instanceId: string; rowIndex: number; chunkIndex: number }>(),
  ),
  ExpandRow: createAction(
    '[Paged grid] expand row',
    props<{ instanceId: string; rowIndex: number; rowIndexInChunk: number; chunkIndex: number }>(),
  ),
  CollapseRow: createAction(
    '[Paged grid] collapse row',
    props<{ instanceId: string; rowIndex: number; rowIndexInChunk: number; chunkIndex: number }>(),
  ),
  ChangeSortColumn: createAction(
    '[Paged grid] change sort column',
    props<{ instanceId: string; columnName: string }>(),
  ),
  TrackSortColumnEvent: createAction(
    '[Paged grid] track sort column event',
    props<{ columnName: string; sortDirection: string }>(),
  ),
};

export const PagedActionsTypesSet = new Set([...Object.values(PagedGridActions).map((action) => action.type as string)]);
